import { Competency, CompetencyLevel } from 'shared-types';
import { GetCompetenciesRes } from 'shared-types/responses';

export type LevelSeparatedCompetency = Pick<
  Competency,
  | 'allowUserSelfAdding'
  | 'id'
  | 'description'
  | 'descriptionLocales'
  | 'enableLevels'
  | 'name'
  | 'nameLocales'
> & {
  categories: string[];
  level?: Pick<
    CompetencyLevel,
    | 'id'
    | 'description'
    | 'descriptionLocales'
    | 'level'
    | 'name'
    | 'nameLocales'
  >;
};

const getLevelSeparatedCompetencies = (
  competencies: GetCompetenciesRes['competencyObjs']
) => {
  const levelSeparatedCompetencies: LevelSeparatedCompetency[] = [];

  competencies.forEach((competency) => {
    const { levels, ...attrs } = competency;

    if (levels?.length) {
      levels.forEach((level) => {
        levelSeparatedCompetencies.push({
          ...attrs,
          level
        });
      });
    } else {
      levelSeparatedCompetencies.push({
        ...attrs
      });
    }
  });

  return levelSeparatedCompetencies;
};

export default getLevelSeparatedCompetencies;
